// src/services/pelunasanStore.js
//
// Pencatatan PELUNASAN (settlement) per NOMOR STRUK — bukan per item.
//
// Sumber invoice (`/datadigi/invoice-details`) bersifat per item dan tidak bisa
// kita tulis. Karena belum ada tabel pelunasan di backend, entri pelunasan
// disimpan lokal di browser (localStorage) sebagai "tabel" terpisah yang
// di-JOIN ke data struk berdasarkan `strukno`. Mendukung pelunasan bertahap
// (partial): satu struk bisa punya banyak entri pembayaran.
//
// Bentuk data tersimpan:
//   { [strukno]: [ { id, amount, date, method, note, createdAt } ] }
//
// Saat backend menyediakan tabel pelunasan, cukup ganti read/write di sini
// menjadi pemanggilan API dengan kontrak yang sama (per strukno).

const STORAGE_KEY = 'digital_pelunasan_v1';

const readAll = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeAll = (obj) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
    // Notify same-tab listeners (storage event only fires cross-tab).
    window.dispatchEvent(new Event('pelunasan-updated'));
  } catch (e) {
    console.error('Gagal menyimpan pelunasan', e);
  }
};

const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

// Semua pelunasan untuk satu struk (array, urut terlama→terbaru).
export const getPelunasan = (strukno) => {
  if (!strukno) return [];
  const all = readAll();
  return Array.isArray(all[strukno]) ? all[strukno] : [];
};

// Map { strukno: totalDibayar } untuk join cepat ke daftar struk.
export const getPelunasanTotals = () => {
  const all = readAll();
  const totals = {};
  Object.entries(all).forEach(([struk, entries]) => {
    if (Array.isArray(entries)) {
      totals[struk] = entries.reduce((s, e) => s + (Number(e.amount) || 0), 0);
    }
  });
  return totals;
};

export const totalForStruk = (strukno) =>
  getPelunasan(strukno).reduce((s, e) => s + (Number(e.amount) || 0), 0);

// Tambah satu entri pelunasan (partial diperbolehkan).
export const addPelunasan = (strukno, { amount, date, method = 'CASH', note = '' }) => {
  const amt = Number(amount) || 0;
  if (!strukno || amt <= 0) return null;
  const all = readAll();
  const entry = {
    id: uid(),
    amount: amt,
    date: date || new Date().toISOString().slice(0, 10),
    method,
    note,
    createdAt: new Date().toISOString(),
  };
  all[strukno] = [...(all[strukno] || []), entry];
  writeAll(all);
  return entry;
};

export const deletePelunasan = (strukno, id) => {
  const all = readAll();
  if (!Array.isArray(all[strukno])) return;
  all[strukno] = all[strukno].filter((e) => e.id !== id);
  if (all[strukno].length === 0) delete all[strukno];
  writeAll(all);
};

export const PELUNASAN_EVENT = 'pelunasan-updated';
